var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-body" }, [
    _vm.itemsData.items && _vm.itemsData.items.length
      ? _c(
          "div",
          { staticClass: "search-section" },
          [
            _c(
              "page-limiter",
              [
                _c("h1", { staticClass: "page-title search-section__title" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(_vm.countTitle) + " "),
                  _vm.req
                    ? _c("span", [_vm._v("«" + _vm._s(_vm.req) + "»")])
                    : _vm._e()
                ]),
                _vm.itemsData.items && _vm.itemsData.items.length
                  ? _c(
                      "ul",
                      { staticClass: "catalog-grid" },
                      _vm._l(_vm.itemsData.items, function(item) {
                        return _c(
                          "li",
                          {
                            class: [
                              "catalog-grid__item",
                              { "catalog-grid__item--wide": item.wide }
                            ]
                          },
                          [_c("product-tile", { attrs: { content: item } })],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.itemsData.count && _vm.itemsData.perPage
                  ? _c("pagination", {
                      attrs: {
                        total: _vm.itemsData.count,
                        perPage: _vm.itemsData.perPage
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "search-section search-empty" },
          [
            _c("page-limiter", [
              _c("div", { staticClass: "search-section__body" }, [
                _c("div", { staticClass: "search-message" }, [
                  _c(
                    "h1",
                    { staticClass: "page-title search-message__title" },
                    [
                      _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.emptyTitle) + " "),
                      _vm.req
                        ? _c("span", [_vm._v("«" + _vm._s(_vm.req) + "»")])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "svg",
                    {
                      attrs: { width: "98", height: "98", viewBox: "0 0 98 98" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M59.7 0C38.6 0 21.4 17.2 21.3 38.3c0 7.7 2.3 14.8 6.2 20.8L0 86.6 11.4 98l27.5-27.5c6 3.9 13.1 6.2 20.8 6.2C80.8 76.6 98 59.5 98 38.3 98 17.2 80.8 0 59.7 0zm0 60.6c-12.3 0-22.2-10-22.3-22.3 0-12.3 10-22.2 22.3-22.2S82 26.1 82 38.4c-.1 12.2-10.1 22.2-22.3 22.2z",
                          fill: "#c7beb5"
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fd6e89d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd6e89d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageSearch.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3fd6e89d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageSearch.vue
// module chunks = 0